import * as React from "react";
const SvgFiRrDirectionSignal = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="m22.707 13.793-1.914-1.914A2.98 2.98 0 0 0 18.671 11h-5.67V9h6.5C20.877 9 22 7.878 22 6.5v-2C22 3.122 20.877 2 19.5 2h-6.507L13 1.006A1 1 0 0 0 12.005 0H12a1 1 0 0 0-1 .994L10.994 2H5.328c-.8 0-1.555.312-2.122.879L1.292 4.793a1 1 0 0 0 0 1.414l1.914 1.914c.566.567 1.32.879 2.122.879H11v2H4.5A2.503 2.503 0 0 0 2 13.5v2C2 16.878 3.121 18 4.5 18h6.491l.01 5.002A1 1 0 0 0 12 24H12A1 1 0 0 0 13 22.998L12.99 18h5.681c.801 0 1.555-.312 2.122-.879l1.914-1.914a1 1 0 0 0 0-1.414M4.621 6.707 3.414 5.5l1.207-1.207A1 1 0 0 1 5.33 4H19.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H5.33a1 1 0 0 1-.709-.293m14.758 9a1 1 0 0 1-.708.293H4.501a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h14.17c.267 0 .52.104.708.293l1.207 1.207z"
    />
  </svg>
);
export default SvgFiRrDirectionSignal;
